import React from 'react';
import { Button, Space } from 'antd';
import { 
    PlayCircleOutlined, 
    QuestionCircleOutlined, 
    CheckCircleOutlined, 
    ArrowRightOutlined 
} from '@ant-design/icons';
import s from '../../s.module.less';

interface INodePaletteProps {
    onAddNode: (nodeType: string, position?: { x: number; y: number }) => void;
}

const NodePalette: React.FC<INodePaletteProps> = ({ onAddNode }) => {
    const nodeTypes = [
        {
            type: 'start',
            label: 'Start',
            icon: <PlayCircleOutlined />,
            color: '#52c41a',
        },
        {
            type: 'question',
            label: 'Question',
            icon: <QuestionCircleOutlined />,
            color: '#1890ff',
        },
        {
            type: 'result',
            label: 'Result',
            icon: <CheckCircleOutlined />,
            color: '#fa8c16',
        },
        {
            type: 'jump',
            label: 'Jump',
            icon: <ArrowRightOutlined />,
            color: '#722ed1',
        },
    ];

    const handleDragStart = (event: React.DragEvent, nodeType: string) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    return (
        <div className={s.nodePalette}>
            {nodeTypes.map((node) => (
                <div
                    key={node.type}
                    className={s.nodeItem}
                    draggable
                    onDragStart={(e) => handleDragStart(e, node.type)}
                    onClick={() => onAddNode(node.type)}
                >
                    <div
                        className={s.nodeIcon}
                        style={{ backgroundColor: node.color }}
                    >
                        {node.icon}
                    </div>
                    <div className={s.nodeLabel}>{node.label}</div>
                </div>
            ))}
        </div>
    );
};

export default NodePalette;
